import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Router,
  Switch,
  Route,
  useHistory,
  useLocation,
} from "react-router-dom";
import Login from "./components/Login";
import Reject from "./components/Reject";

import LandingPage from "./pages/Landingpage";
import VerifyMail from "./pages/VerifyMail";
import ResetSuccess from "./components/Forgot_pwd/resetSuccess";
import Console from "./pages/console/Console";

import SignUp from "./components/Signup";
import Organization from "./components/Organization";
import JoinOrganization from "./components/joinOrganization";
import designExplore from "./components/DesignExplore";
import Create from "./components/Create";
import developExplore from "./components/DevelopExplore";
import forgotPwd from "./components/Forgot_pwd/forgotPwd";
import resetLink from "./components/Forgot_pwd/resetLink";
import resetPwd from "./components/Forgot_pwd/resetPwd";
// import PageNotFound from "../pages/error"; not used

import CustomLoader from "./util/loader/CustomLoader";
import PrivateRoute from "./util/HOCs/PrivateRoute";
import ScrollToTop from "./util/HOCs/ScrollToTop";
import PageNotFound from "./pages/errorPages/PageNotFound";
import ErrorHandler from "./util/HOCs/ErrorHandler";
// import PrivateRoute from "./util/HOCs/PrivateRoute";
// import Container from "./pages/container"
import { version } from "../package.json";
import SnackbarToast from "./util/snackbar-toast/SnackbarToast";
import {
  CustomToast,
  CustomToastContainer,
} from "./util/custom-toast/CustomToast";
import MailExpiry from "./pages/auth/mail-expiry";
import RedirectTo from "./pages/redirect-to";
import JoinDiscord from "./pages/join-discord";
import Downloads from "./pages/downloads";
import { migrateToBUBasedDC } from "./util/helpers/funcHelper";
function App() {
  let history = useHistory();
  const location = useLocation();
  // document.querySelector('body').setAttribute('version',version)
  document.querySelector("title").innerText = "Dev Console V" + version;
  let [online, isOnline] = useState("");
  const [showToast, setShowToast] = useState({ status: false, msg: "" });
  const notifyOnlineStatus = () => {
    if (document.querySelector("body").classList.contains("c-pointer-block")) {
    }
  };

  const setOnline = () => {
    isOnline("true");
    window.removeEventListener("click", notifyOnlineStatus);
  };
  const setOffline = () => {
    isOnline("false");
    window.addEventListener("click", notifyOnlineStatus);
  };
  useEffect(() => {
    window.addEventListener("offline", setOffline);
    window.addEventListener("online", setOnline);
    return () => {
      window.removeEventListener("offline", setOffline);
      window.removeEventListener("online", setOnline);
    };
  }, []);

  useEffect(() => {
    if (online === "false") {
      CustomToast("Internet disconnected!");
      // setShowToast({status:true,msg:"Internet disconnected!"})
      document.querySelector("body").classList.add("c-pointer-block");
    } else if (online === "true") {
      CustomToast("Internet connected!");
      // setShowToast({status:true,msg:"Internet connected!"})
      document.querySelector("body").classList.remove("c-pointer-block");
    }
  }, [online]);

  useLayoutEffect(() => {
    /** if enterprise user and url is not of enterprise dc then open enterprise dc */
    const dc_origin = migrateToBUBasedDC(location, window.location);
    if (dc_origin)
      window.location.replace(
        dc_origin + location.pathname + location.search + location.hash
      );
  }, [location.search, location.hash]);

  return (
    <>
      <CustomToastContainer />
      {/* <SnackbarToast  showToast={showToast} setShowToast={setShowToast}/> */}
      <CustomLoader />
      <Router history={history}>
        <ErrorHandler>
          <ScrollToTop>
            <Switch>
              {/* Routes for Public Pages */}
              <Route exact path="/" component={LandingPage} />
              <Route path="/login" component={Login} />
              <Route path="/reject" component={Reject} />
              <Route path="/signup" component={SignUp} />
              <Route path="/verify-mail" component={VerifyMail} />
              <Route path="/mail-verified" component={VerifyMail} />
              <Route path="/mail-expired" component={MailExpiry} />
              <Route path="/explore/design" component={designExplore}></Route>
              <Route path="/explore/develop" component={developExplore}></Route>
              <Route exact path="/join-discord" component={JoinDiscord}></Route>

              {/* Routes for Organization Create */}

              <Route path="/organization" component={Organization}></Route>
              <Route
                path="/join-organization"
                component={JoinOrganization}
              ></Route>
              <Route path="/create" component={Create}></Route>

              {/* Routes for Password Reset Flow */}
              <Route path="/forgot-password" component={forgotPwd}></Route>
              <Route path="/reset-link" component={resetLink}></Route>
              <Route path="/reset-password" component={resetPwd}></Route>
              <Route path="/reset-success" component={ResetSuccess}></Route>
              <Route path="/redirect" component={RedirectTo}></Route>
              {/* Routes for Console Dashboard - prefix: /console */}

              <PrivateRoute path="/console" component={Console} />
              <PrivateRoute exact path="/downloads" component={Downloads} />

              {/* Error 404 Page not found route */}
              <Route path="*" component={PageNotFound} />
            </Switch>
          </ScrollToTop>
        </ErrorHandler>
      </Router>
    </>
  );
}

export default App;
